"use client";
import React from "react";
import Arrow from "@/src/icons/Arrow";
import useOnScreen from "@/src/hooks/useOnScreen";
import useTextColorBasedOnBackground from "@/src/hooks/useTextColorBasedOnBackground";
import { AnimatedButtonProps } from "./types";

const AnimatedSliderButton: React.FC<AnimatedButtonProps & { totalItems: number }> = ({
  item,
  index,
  onMouseEnter,
  color,
  onClick,
  totalItems,
}) => {
  const { ref, isIntersecting } = useOnScreen<HTMLDivElement>(0, true);
  const textColorClass = useTextColorBasedOnBackground(color);

  const buttonHeight = (550 - (totalItems - 1) * 32) / totalItems;

  return (
    <div
      ref={ref}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
      className={`relative flex w-full items-center justify-between px-4 sm:px-20 border-[#A9AEAA] hover:bg-opacity-80 cursor-pointer
        transform transition-transform duration-700 ease-in-out ${
          isIntersecting ? "translate-x-0 opacity-100" : "-translate-x-full opacity-0"
        }`}
      style={{
        backgroundColor: color,
        transitionDelay: `${index * 100}ms`,
        height: `${buttonHeight}px`,
      }}
    >
      <span className={`text-lg sm:text-2xl font-light tracking-wide min-w-[100px] ${textColorClass}`}>
        {item}
      </span>
      <span className={`text-2xl sm:text-4xl`}>
        <Arrow direction="right" />
      </span>
    </div>
  );
};

export default AnimatedSliderButton;
